import React from "react"

import { getIcon } from "../../utils/helpers"

export default function SkillItem({ name, classN, link }) {
    return (
        <a href={link} target="_blank" rel="noreferrer">
            <div className={`skill ${classN}`}>
                {getIcon(classN)}
                <p>{name}</p>
            </div>
        </a>
    )
}
